// extracted by mini-css-extract-plugin
export var divider = "_lv-0";
export var labelWrapper = "_lv-2";
export var lineSvg = "_lv-1";